import React, { useEffect, useState } from "react";
import { ScrollText, Check } from "lucide-react";

const STORAGE_KEY = "ks_bci_disclaimer_v1";

export default function DisclaimerModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      const accepted = sessionStorage.getItem(STORAGE_KEY);
      if (!accepted) setOpen(true);
    } catch {
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
  }, [open]);

  const accept = () => {
    try { sessionStorage.setItem(STORAGE_KEY, "1"); } catch (_) { /* ignore */ }
    setOpen(false);
  };

  const decline = () => {
    window.location.href = "https://www.google.com";
  };

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4 py-6"
      data-testid="disclaimer-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="disclaimer-title"
      style={{ backgroundColor: "rgba(10, 17, 40, 0.78)", backdropFilter: "blur(6px)" }}
    >
      <div
        className="w-full max-w-3xl max-h-[92vh] flex flex-col"
        style={{
          backgroundColor: "#F9F6F0",
          border: "1px solid #C5A059",
          boxShadow: "0 30px 80px rgba(0,0,0,0.45)",
        }}
      >
        <div
          className="px-6 sm:px-10 pt-8 pb-6 flex items-start gap-5"
          style={{ borderBottom: "1px solid #E2DCD0" }}
        >
          <div
            className="hidden sm:flex items-center justify-center shrink-0"
            style={{ width: 56, height: 56, border: "1px solid #C5A059", color: "#7A2021" }}
          >
            <ScrollText size={26} strokeWidth={1.4} />
          </div>
          <div>
            <span
              className="text-[10px] uppercase"
              style={{ color: "#7A2021", letterSpacing: "0.28em" }}
            >
              Bar Council of India · Mandatory Notice
            </span>
            <h2
              id="disclaimer-title"
              className="font-serif-display text-3xl sm:text-4xl mt-2"
              style={{ color: "#0A1128", fontWeight: 500, lineHeight: 1.1 }}
            >
              Disclaimer
            </h2>
          </div>
        </div>

        <div
          className="px-6 sm:px-10 py-6 overflow-y-auto"
          data-testid="disclaimer-content"
          style={{ color: "#334155", lineHeight: 1.8 }}
        >
          <p className="text-sm sm:text-base">
            The <strong style={{ color: "#0A1128" }}>Bar Council of India</strong> does not permit
            advertisement or solicitation by advocates in any form or manner. By accessing this
            website, you acknowledge and confirm that you are seeking information relating to{" "}
            <strong style={{ color: "#0A1128" }}>Sikdar &amp; Sikdar, Advocates</strong> (&ldquo;the
            Chambers&rdquo;) of your own accord, and that there has been no form of solicitation,
            advertisement or inducement by the Chambers or any of its members.
          </p>
          <p className="mt-5 text-sm sm:text-base">
            The content of this website is for informational purposes only and should not be
            interpreted as soliciting or advertisement. No material or information provided on this
            website should be construed as legal advice. The Chambers shall not be liable for the
            consequences of any action taken by relying on the material or information provided on
            this website. The contents of this website are the intellectual property of the
            Chambers.
          </p>
        </div>

        <div
          className="px-6 sm:px-10 py-5 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-between gap-3"
          style={{ borderTop: "1px solid #E2DCD0", backgroundColor: "#FFFFFF" }}
        >
          <button
            type="button"
            className="btn-secondary w-full sm:w-auto"
            onClick={decline}
            data-testid="disclaimer-decline"
          >
            Decline & Exit
          </button>
          <button
            type="button"
            className="btn-primary w-full sm:w-auto"
            style={{ backgroundColor: "#7A2021", borderColor: "#7A2021" }}
            onClick={accept}
            data-testid="disclaimer-agree"
            autoFocus
          >
            <Check size={14} strokeWidth={2} /> I Agree
          </button>
        </div>
      </div>
    </div>
  );
}

function DiscItem({ children }) {
  return (
    <li className="flex gap-3">
      <span
        className="mt-2 inline-block shrink-0"
        style={{ width: 14, height: 1, backgroundColor: "#C5A059" }}
      />
      <span>{children}</span>
    </li>
  );
}
